import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import TicketsResource from 'flow/api/omnitickets';
import TicketsSettingsResource from 'flow/api/omniticketsetting';
import Actions from 'flow/actions';
import { i18next } from 'flow/configure-locale';
import { selectOpenTicketsAssignedToLoggedInUserRequestPageNumber, selectOpenTicketsUnassignedRequestPageNumber, selectTicketsAllStatesRequestPageNumber, selectClosedTicketsRequestPageNumber, selectRelatedTicketsRequestPageNumber, selectTicketsListIsMounted, selectTicketsListTabSelected, selectTicket, selectTicketsSettingsForQueue, selectTicketEventsIsMounted, selectTicketsTabIsEnforced, selectOriginDTOSubtype, selectTicketsSortForApi } from 'flow/selectors/TicketsSelectors';
import { onOwnUserRemovedFromTicket, onTicketWriteRefused } from 'flow/actions/ticket-actions';
import { getOwnExtensionKey } from 'flow/selectors/selectors';
import { networkErrorDispatcher, spawnTicketNotification } from 'flow/actions/app-actions';
import { getExtensionContactFirstNameLastName } from 'flow/selectors/extension-selectors';
import { getExtension } from 'flow/selectors/ExtensionSelectors';
import { getContactName } from 'flow/utils/contact-utils';
import { addTicketLogEntry } from 'flow/utils/browser-utils';
import { CALL_RECORD_INCLUDES_TICKET_EVENT } from 'flow/utils/call-record-fetch-includes';
import { eventIsCallRecordEvent } from 'flow/types/TicketEventData';
import { TICKETS_LIST_TABS_KEYS, getTicketIdUiFriendlyFromTicketKey, ticketVisibilityFromWire } from 'flow/utils/ticket-utils';
import { getStringWithFirstLetterFromSecondWord, isExtensionKey } from 'flow/utils';
import { selectShouldSeeTicketsTab, selectTagExistsInAvailableTags, selectTagFromAllTagsWithLabel, selectTicketIsFetched, selectTicketViewsMountedData } from 'flow/selectors/TicketsSelectors';
import { selectOwnExtensionKey, selectUserCountryCode } from 'flow/selectors/ExtensionSelectors';
import { selectAppIsVisibleAndFocused, selectPbxPageIsMounted } from 'flow/selectors/app-selectors';
import icon_whatsapp from 'images/omnichannel/whatsapp_black.png';
import icon_email from 'images/omnichannel/omnichannel_email.svg';
import { prettyFormatE164Number } from 'flow/utils/call-utils';
import { isTypeQueueKey } from 'flow/utils/pbx-utils-TW';
import { selectQueueMembers } from 'flow/selectors/queue-selectors';
import { selectMessageEventLacksStylings } from 'flow/selectors/TicketEventSelectors';
import { getPlaceholderEventsFromLocalStorage } from 'flow/components/tickets/Input/InputActions';
var TICKETS_PAGE_SIZE = 25;
var ONE_SECOND_MILLISECONDS = 1000;

// Shared request plumbing for the tab lists. Each tab keeps its own fetch
// method (below) that supplies the appropriate assignee/state filter; they all
// hit the generic tickets endpoint with the globally selected sort applied.
var fetchTicketsListPage = function fetchTicketsListPage(_ref) {
  var pageNumber = _ref.pageNumber,
    nextPageNumber = _ref.nextPageNumber,
    assignee = _ref.assignee,
    ticketState = _ref.state,
    setData = _ref.setData;
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      var _selectTicketsSortFor = selectTicketsSortForApi(getState()),
        sortField = _selectTicketsSortFor.sortField,
        sortDirection = _selectTicketsSortFor.sortDirection;
      TicketsResource.getTickets({
        onResult: function onResult(json) {
          var apiHasMoreData = json.length === TICKETS_PAGE_SIZE;
          dispatch(setData(json, nextPageNumber, apiHasMoreData));
          resolve(json);
        },
        onClientError: function onClientError(/*error*/
        ) {
          reject();
        },
        onError: function onError(/*error*/
        ) {
          networkErrorDispatcher(dispatch);
          reject();
        }
      }, TICKETS_PAGE_SIZE, pageNumber, undefined,
      // searchParam
      assignee, ticketState, undefined,
      // since
      undefined,
      // countOnly
      undefined,
      // marked
      undefined,
      // sessionIds
      undefined,
      // tagKeysOr
      sortField, sortDirection);
    });
  };
};
export var fetchTicket = function fetchTicket(ticketKey) {
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      TicketsResource.getTicket({
        onResult: function onResult(json) {
          var ownExtensionKey = getOwnExtensionKey(getState());
          dispatch(setTicketData(json, ownExtensionKey));
          resolve(json);
        },
        onClientError: function onClientError(error) {
          reject(error);
        },
        onError: function onError(error) {
          networkErrorDispatcher(dispatch);
          reject(error);
        }
      }, ticketKey);
    });
  };
};
export var createTicketForOngoingQueueCall = function createTicketForOngoingQueueCall(locutusSessionId) {
  return function (dispatch, getState) {
    if (!locutusSessionId) return Promise.reject({
      message: 'No locutusSessionId provided'
    });
    var callRecordKey = "call-".concat(locutusSessionId);
    var ownExtensionKey = selectOwnExtensionKey(getState());
    return new Promise(function (resolve, reject) {
      dispatch(createTicketForQueueCall(callRecordKey, [ownExtensionKey], ownExtensionKey, true)).then(function (data) {
        resolve(data);
      })["catch"](function (error) {
        reject(error);
      });
    });
  };
};
export var createTicketForQueueCall = function createTicketForQueueCall(callRecordEntityKey, members, assignee) {
  var lookForQueueCallParent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return function (dispatch, getState) {
    var payload = {
      callRecordEntityKey: callRecordEntityKey,
      members: members,
      assignee: assignee,
      lookForQueueCallParent: lookForQueueCallParent
    };
    return new Promise(function (resolve, reject) {
      TicketsResource.createNewTicket({
        onResult: function onResult(data) {
          var _data$origin;
          var queueKey = (_data$origin = data.origin) === null || _data$origin === void 0 ? void 0 : _data$origin.key;
          var ticketKey = data.key;
          dispatch(setTicketKeyForQueueCallRecord(queueKey, callRecordEntityKey, ticketKey));
          var ownExtensionKey = selectOwnExtensionKey(getState());
          dispatch(setTicketData(data, ownExtensionKey));
          resolve(data);
        },
        onClientError: function onClientError(response) {
          reject(response);
        },
        onError: function onError(response) {
          networkErrorDispatcher(dispatch);
          reject(response);
        }
      }, payload);
    });
  };
};

// Method below, sendMessage, to be deleted in favor of method above,
// sendInternalNote, once v1 components are to be removed
export var sendMessage = function sendMessage(ticketKey, message, mentions) {
  return function (dispatch, getState) {
    var state = getState();
    var internalNoteDTOForApi = {
      DTOSubtype: 'OmniInternalNoteTicketEvent',
      message: message,
      stylings: mentions,
      sender: getOwnExtensionKey(state),
      read: true
    };
    //TODO: #team-omni this needs some consideration what if we fail??
    TicketsResource.addInternalNote({
      onResult: function onResult(json) {
        dispatch(addTicketEvent(json, ticketKey));
      },
      onError: function onError(/*error*/
      ) {
        networkErrorDispatcher(dispatch);
      }
    }, ticketKey, internalNoteDTOForApi);
  };
};
export var sendMessageAsSMSv1Method = function sendMessageAsSMSv1Method(ticketKey, message) {
  return function (dispatch, getState) {
    var state = getState();
    var smsNoteDTOForApi = {
      DTOSubtype: 'OmniSmsNoteTicketEvent',
      message: message,
      sender: getOwnExtensionKey(state),
      read: true
    };

    //TODO: #team-omni this needs some consideration what if we fail??
    TicketsResource.sendSMS({
      onResult: function onResult(json) {
        dispatch(addTicketEvent(json, ticketKey));
      },
      onError: function onError(/*error*/
      ) {
        networkErrorDispatcher(dispatch);
      }
    }, ticketKey, smsNoteDTOForApi);
  };
};
export var fetchTicketEvents = function fetchTicketEvents(ticketKey) {
  return function (dispatch, getState) {
    var messageTypeToRequest = selectOriginDTOSubtype(getState(), ticketKey) === 'email' ? 'rich' : '';
    return new Promise(function (resolve, reject) {
      TicketsResource.getTicketEvents({
        onResult: function onResult(data) {
          var placeholderEvents = getPlaceholderEventsFromLocalStorage(ticketKey);
          var mergedData = data.concat(placeholderEvents);
          dispatch(setTicketEvents(mergedData, ticketKey));
          resolve(data);
        },
        onClientError: function onClientError(error) {
          reject(error);
        },
        onError: function onError(error) {
          reject(error);
        }
      }, ticketKey, messageTypeToRequest, 3);
    });
  };
};
export var fetchTicketMessage = function fetchTicketMessage(ticketKey, conversationMessageKey, useAttachmentDataOnly) {
  return function (dispatch, getState) {
    var messageTypeToRequest = selectOriginDTOSubtype(getState(), ticketKey) === 'email' ? 'rich' : '';
    return new Promise(function (resolve, reject) {
      TicketsResource.getConversationMessage({
        onResult: function onResult(response) {
          if (useAttachmentDataOnly) {
            dispatch(setTicketEventAttachments(ticketKey, conversationMessageKey, response === null || response === void 0 ? void 0 : response.attachments));
          } else {
            dispatch(addTicketEvent(response, ticketKey));
          }
          resolve(response);
        },
        onClientError: function onClientError(error) {
          reject(error);
        },
        onError: function onError(error) {
          reject(error);
        }
      }, ticketKey, conversationMessageKey, messageTypeToRequest);
    });
  };
};
var setTicketEventAttachments = function setTicketEventAttachments(ticketKey, eventKey, data) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_TICKET_EVENT_ATTACHMENTS,
      ticketKey: ticketKey,
      eventKey: eventKey,
      data: data
    });
  };
};
export var fetchTicketsSettingsForQueue = function fetchTicketsSettingsForQueue(queueEntityKey) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      TicketsSettingsResource.fetchTicketSettings({
        onResult: function onResult(json) {
          dispatch(setTicketsSettingsInStoreForQueue(queueEntityKey, json));
          resolve();
        },
        onClientError: function onClientError(/*error*/
        ) {
          reject();
        },
        onError: function onError(/*error*/
        ) {
          networkErrorDispatcher(dispatch);
          reject();
        }
      }, queueEntityKey);
    });
  };
};
var createTicketsSettingsForQueue = function createTicketsSettingsForQueue(queueEntityKey, ticketSettingsDTO) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      TicketsSettingsResource.createTicketSettings({
        onResult: function onResult(json) {
          dispatch(setTicketsSettingsInStoreForQueue(queueEntityKey, json));
          resolve();
        },
        onClientError: function onClientError(/*error*/
        ) {
          reject();
        },
        onError: function onError(/*error*/
        ) {
          networkErrorDispatcher(dispatch);
          reject();
        }
      }, queueEntityKey, ticketSettingsDTO);
    });
  };
};
var updateTicketsSettingsForQueue = function updateTicketsSettingsForQueue(ticketSettingsKey, queueEntityKey, ticketSettingsDTO) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      TicketsSettingsResource.updateTicketSettings({
        onResult: function onResult(json) {
          dispatch(setTicketsSettingsInStoreForQueue(queueEntityKey, json));
          resolve();
        },
        onClientError: function onClientError(/*error*/
        ) {
          reject();
        },
        onError: function onError(/*error*/
        ) {
          networkErrorDispatcher(dispatch);
          reject();
        }
      }, ticketSettingsKey, ticketSettingsDTO);
    });
  };
};
export var fetchDefaultTicketVisibilityForQueue = function fetchDefaultTicketVisibilityForQueue(queueEntityKey) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      TicketsResource.getDefaultTicketVisibility({
        onResult: function onResult(json) {
          dispatch(setDefaultTicketVisibilityInStoreForQueue(queueEntityKey, json));
          resolve();
        },
        onClientError: function onClientError(/*error*/
        ) {
          reject();
        },
        onError: function onError(/*error*/
        ) {
          networkErrorDispatcher(dispatch);
          reject();
        }
      }, queueEntityKey);
    });
  };
};
export var setDefaultTicketVisibilityForQueue = function setDefaultTicketVisibilityForQueue(queueEntityKey, visibility) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      TicketsResource.setDefaultTicketVisibility({
        onResult: function onResult(json) {
          dispatch(setDefaultTicketVisibilityInStoreForQueue(queueEntityKey, json));
          resolve();
        },
        onClientError: function onClientError(/*error*/
        ) {
          reject();
        },
        onError: function onError(/*error*/
        ) {
          networkErrorDispatcher(dispatch);
          reject();
        }
      }, queueEntityKey, {
        visibility: visibility
      });
    });
  };
};
export var setTicketsSettingsForQueue = function setTicketsSettingsForQueue(queueEntityKey, settingPathName, value) {
  return function (dispatch, getState) {
    var ticketsSettingsDTO = selectTicketsSettingsForQueue(getState(), queueEntityKey).set(settingPathName, value);
    var ticketSettingsKey = ticketsSettingsDTO.get('key');
    var ticketSettingsDTOApiFriendly = ticketsSettingsDTO.toJS();
    return new Promise(function (resolve /*, reject*/) {
      if (ticketSettingsKey) {
        dispatch(updateTicketsSettingsForQueue(ticketSettingsKey, queueEntityKey, ticketSettingsDTOApiFriendly))["finally"](function () {
          resolve();
        });
      } else {
        dispatch(createTicketsSettingsForQueue(queueEntityKey, ticketSettingsDTOApiFriendly))["finally"](function () {
          resolve();
        });
      }
    });
  };
};
export var fetchOpenTicketsAssignedToUserLatest = function fetchOpenTicketsAssignedToUserLatest(dispatch, getState) {
  return dispatch(fetchTicketsListPage({
    pageNumber: 0,
    nextPageNumber: undefined,
    assignee: selectOwnExtensionKey(getState()),
    state: 'open',
    setData: setOpenTicketsAssignedToUserData
  }));
};
export var fetchOpenTicketsAssignedToUserNext = function fetchOpenTicketsAssignedToUserNext(dispatch, getState) {
  var pageNumber = selectOpenTicketsAssignedToLoggedInUserRequestPageNumber(getState());
  return dispatch(fetchTicketsListPage({
    pageNumber: pageNumber,
    nextPageNumber: pageNumber + 1,
    assignee: selectOwnExtensionKey(getState()),
    state: 'open',
    setData: setOpenTicketsAssignedToUserData
  }));
};
export var fetchOpenTicketsUnassignedLatest = function fetchOpenTicketsUnassignedLatest(dispatch) {
  return dispatch(fetchTicketsListPage({
    pageNumber: 0,
    nextPageNumber: undefined,
    assignee: 'unassigned',
    state: 'open',
    setData: setOpenTicketsUnassignedData
  }));
};
export var fetchOpenTicketsUnassignedNext = function fetchOpenTicketsUnassignedNext(dispatch, getState) {
  var pageNumber = selectOpenTicketsUnassignedRequestPageNumber(getState());
  return dispatch(fetchTicketsListPage({
    pageNumber: pageNumber,
    nextPageNumber: pageNumber + 1,
    assignee: 'unassigned',
    state: 'open',
    setData: setOpenTicketsUnassignedData
  }));
};
export var fetchTicketsAllLatest = function fetchTicketsAllLatest(dispatch) {
  return dispatch(fetchTicketsListPage({
    pageNumber: 0,
    nextPageNumber: undefined,
    assignee: undefined,
    state: undefined,
    setData: setTicketsAllData
  }));
};
export var fetchTicketsAllNext = function fetchTicketsAllNext(dispatch, getState) {
  var pageNumber = selectTicketsAllStatesRequestPageNumber(getState());
  return dispatch(fetchTicketsListPage({
    pageNumber: pageNumber,
    nextPageNumber: pageNumber + 1,
    assignee: undefined,
    state: undefined,
    setData: setTicketsAllData
  }));
};
export var fetchTicketsRelatedCount = function fetchTicketsRelatedCount(ticketKey) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      TicketsResource.countRelatedTickets({
        onResult: function onResult(json) {
          var count = parseInt(json, 10);
          dispatch(setTotalNumberOfRelatedTickets(ticketKey, count));
          resolve();
        },
        onClientError: function onClientError() {
          reject();
        },
        onError: function onError() {
          networkErrorDispatcher(dispatch);
          reject();
        }
      }, ticketKey);
    });
  };
};
export var fetchRelatedTicketsLatest = function fetchRelatedTicketsLatest(ticketKey) {
  return function (dispatch, getState) {
    var _selectTicketsSortFor2 = selectTicketsSortForApi(getState()),
      sortField = _selectTicketsSortFor2.sortField,
      sortDirection = _selectTicketsSortFor2.sortDirection;
    return new Promise(function (resolve, reject) {
      TicketsResource.fetchRelatedTickets({
        onResult: function onResult(json) {
          var apiHasMoreData = json.length === TICKETS_PAGE_SIZE;
          dispatch(setTicketsRelatedData(ticketKey, json, undefined, apiHasMoreData));
          resolve();
        },
        onClientError: function onClientError(/* error */
        ) {
          reject();
        },
        onError: function onError() {
          networkErrorDispatcher(dispatch);
          reject();
        }
      }, ticketKey, TICKETS_PAGE_SIZE, 0, sortField, sortDirection);
    });
  };
};
export var fetchRelatedTicketsNext = function fetchRelatedTicketsNext(ticketKey) {
  return function (dispatch, getState) {
    var pageNumber = selectRelatedTicketsRequestPageNumber(getState(), ticketKey);
    var _selectTicketsSortFor3 = selectTicketsSortForApi(getState()),
      sortField = _selectTicketsSortFor3.sortField,
      sortDirection = _selectTicketsSortFor3.sortDirection;
    return new Promise(function (resolve, reject) {
      TicketsResource.fetchRelatedTickets({
        onResult: function onResult(json) {
          var nextPageNumber = pageNumber + 1;
          var apiHasMoreData = json.length === TICKETS_PAGE_SIZE;
          dispatch(setTicketsRelatedData(ticketKey, json, nextPageNumber, apiHasMoreData));
          resolve();
        },
        onClientError: function onClientError(/*error*/
        ) {
          reject();
        },
        onError: function onError() {
          networkErrorDispatcher(dispatch);
          reject();
        }
      }, ticketKey, TICKETS_PAGE_SIZE, pageNumber, sortField, sortDirection);
    });
  };
};
export var fetchArchivedTicketsNext = function fetchArchivedTicketsNext(dispatch, getState) {
  var pageNumber = selectClosedTicketsRequestPageNumber(getState());
  return dispatch(fetchTicketsListPage({
    pageNumber: pageNumber,
    nextPageNumber: pageNumber + 1,
    assignee: undefined,
    state: 'closed',
    setData: setClosedTickets
  }));
};
export var fetchArchivedTicketsLatest = function fetchArchivedTicketsLatest(dispatch) {
  return dispatch(fetchTicketsListPage({
    pageNumber: 0,
    nextPageNumber: undefined,
    assignee: undefined,
    state: 'closed',
    setData: setClosedTickets
  }));
};

/**
 * Sends a partial update, carrying only the fields named in the patch.
 *
 * This is how a single-field change should go out. The alternative is sending the
 * whole ticket back, which replaces it wholesale and so reverts anything a
 * colleague changed while we held our copy — last write wins, on fields we never
 * touched. Assignee and state are the two a queue's agents change at the same
 * moment, so they are where it bites.
 */
var patchTicket = function patchTicket(ticketKey, patch) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      TicketsResource.patchTicket({
        onResult: function onResult(json) {
          dispatch(setTicket(ticketKey, json));
          resolve(json);
        },
        onClientError: function onClientError(error) {
          dispatch(onTicketWriteRefused(ticketKey, error));
          reject(error);
        },
        onError: function onError(error) {
          networkErrorDispatcher(dispatch);
          reject(error);
        }
      }, ticketKey, patch);
    });
  };
};

// Unassigning has its own flag because the payload cannot say it any other way:
// an omitted key and an explicit null both arrive at the backend as absent, which
// means leave the assignee alone.
export var updateTicketAssignee = function updateTicketAssignee(ticketKey, newAssignee) {
  return function (dispatch) {
    return dispatch(patchTicket(ticketKey, newAssignee === 'unassigned' ? {
      clearAssignee: true
    } : {
      assignee: newAssignee
    }));
  };
};
export var updateTicketState = function updateTicketState(ticketKey, newTicketState) {
  return function (dispatch) {
    return dispatch(patchTicket(ticketKey, {
      state: newTicketState
    }));
  };
};
export var updateTicketVisibility = function updateTicketVisibility(ticketKey, newVisibility) {
  return function (dispatch) {
    return dispatch(patchTicket(ticketKey, {
      visibility: newVisibility
    }));
  };
};
export var updateTicketSubject = function updateTicketSubject(ticketKey, subject) {
  return function (dispatch) {
    return dispatch(patchTicket(ticketKey, {
      subject: subject
    }));
  };
};
export var fetchTicketsTabIsEnforcedForUser = function fetchTicketsTabIsEnforcedForUser() {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      TicketsResource.getDisplayTicketTab({
        onResult: function onResult(value) {
          dispatch(setTicketsTabIsEnforcedForUser(value));
          resolve(value);
        },
        onClientError: function onClientError() {
          reject();
        },
        onError: function onError() {
          networkErrorDispatcher(dispatch);
          reject();
        }
      });
    });
  };
};
export var removeTicketMember = function removeTicketMember(ticketKey, extensionKey) {
  return function (dispatch, getState) {
    return new Promise(function (_resolve, reject) {
      TicketsResource.removeMember({
        onResult: function onResult(json) {
          var userRemovedIsLoggedInUser = getOwnExtensionKey(getState()) === extensionKey;
          if (userRemovedIsLoggedInUser) {
            dispatch(onOwnUserRemovedFromTicket(ticketKey, true, [], [extensionKey]));
          } else {
            dispatch(setTicket(ticketKey, json));
          }
        },
        onClientError: function onClientError(error) {
          dispatch(onTicketWriteRefused(ticketKey, error));
          reject(error);
        },
        onError: function onError() {
          networkErrorDispatcher(dispatch);
          reject();
        }
      }, ticketKey, extensionKey);
    });
  };
};
export var fetchTicketsBadgeCount = function fetchTicketsBadgeCount() {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      TicketsResource.getTicketsBadgeCount({
        onResult: function onResult(json) {
          var count = parseInt(json, 10);
          dispatch(setTicketsBadgeCount(count));
          resolve();
        },
        onClientError: function onClientError(error) {
          reject(error);
        },
        onError: function onError(error) {
          networkErrorDispatcher(dispatch);
          reject(error);
        }
      });
    });
  };
};
export var fetchTotalNumberOfTicketsOpenAssignedToLoggedInUser = function fetchTotalNumberOfTicketsOpenAssignedToLoggedInUser(dispatch) {
  return new Promise(function (resolve, reject) {
    TicketsResource.getNumberOfOpenTicketsAssignedToUser({
      onResult: function onResult(json) {
        var count = parseInt(json, 10);
        dispatch(setTotalNumberOfTicketsOpenAssignedToLoggedInUser(count));
        resolve();
      },
      onClientError: function onClientError(/*error*/
      ) {
        reject();
      },
      onError: function onError() {
        networkErrorDispatcher(dispatch);
        reject();
      }
    });
  });
};
var spawnAssigneeSetNotificationIfRelevant = function spawnAssigneeSetNotificationIfRelevant(ticketKey, ownExtensionKey, assigneeKey, actorKey, assigneeIsSetBySystem) {
  return function (dispatch, getState) {
    if (assigneeKey !== ownExtensionKey) {
      //Not the logged-in user that's been assigned; don't display notification
      return;
    }
    if (assigneeIsSetBySystem) {
      //At the time of writing this is true when the ticket is assigned by answering the call; don't display notification
      return;
    }
    if (actorKey === ownExtensionKey) {
      //The ticket's been assigned to the user by herself; don't display notification
      return;
    }
    var actorExtension = getExtension(getState(), actorKey);
    var actorName = actorExtension ? getContactName(actorExtension.get('contact')) : '';
    addTicketLogEntry("Displaying notification for ".concat(ticketKey, " assigned to user"));
    var ticketIdUIFriendly = getTicketIdUiFriendlyFromTicketKey(ticketKey);
    var title = i18next.t('ticket.assigned.to.you');
    var body = i18next.t('ticket.assigned.to.you.extended', {
      ticketId: ticketIdUIFriendly,
      actor: actorName
    });
    dispatch(spawnTicketNotification(ticketKey, title, body));
  };
};
var modifyOpenTicketsAssignedToUserCountOnAssigneeChangeIfAppropriate = function modifyOpenTicketsAssignedToUserCountOnAssigneeChangeIfAppropriate(assigneeNewKey, assigneePrevKey, ticketStateKey, ownExtensionKey) {
  return function (dispatch) {
    if (ticketStateKey !== 'open') {
      return;
    }
    if (assigneeNewKey === ownExtensionKey) {
      dispatch(incrementTicketsOpenAssignedToUserCount);
    } else if (assigneePrevKey === ownExtensionKey) {
      dispatch(decrementTicketsOpenAssignedToUserCount);
    }
  };
};
var modifyOpenTicketsAssignedToUserCountOnTicketStateChangeIfAppropriate = function modifyOpenTicketsAssignedToUserCountOnTicketStateChangeIfAppropriate(ticketStateNewKey, ticketStatePrevKey, assigneeKey, ownExtensionKey) {
  return function (dispatch) {
    if (assigneeKey !== ownExtensionKey) {
      return;
    }
    if (ticketStateNewKey === 'open') {
      dispatch(incrementTicketsOpenAssignedToUserCount);
    } else if (ticketStatePrevKey === 'open') {
      dispatch(decrementTicketsOpenAssignedToUserCount);
    }
  };
};
var previousOrNewAssigneeIsLoggedInUser = function previousOrNewAssigneeIsLoggedInUser(assigneePrevKey, assigneeNewKey, ownExtensionKey) {
  return assigneePrevKey === ownExtensionKey || assigneeNewKey === ownExtensionKey;
};
var spawnTicketStatusSetToOpenNotificationIfRelevant = function spawnTicketStatusSetToOpenNotificationIfRelevant(ticketKey, ownExtensionKey, assigneeKey, ticketStateKey, actorKey, ticketStatusIsSetBySystem) {
  return function (dispatch, getState) {
    if (ticketStateKey !== 'open') {
      return;
    }
    if (assigneeKey !== ownExtensionKey) {
      //Not the logged-in user that is assigned; don't display notification
      return;
    }
    if (ticketStatusIsSetBySystem) {
      return;
    }
    if (actorKey === ownExtensionKey) {
      //The ticket's been opened by the logged-in user; don't display notification
      return;
    }
    var actorExtension = getExtension(getState(), actorKey);
    var actorName = actorExtension ? getContactName(actorExtension.get('contact')) : '';
    addTicketLogEntry("Displaying notification for ".concat(ticketKey, " re-opened"));
    var ticketIdUIFriendly = getTicketIdUiFriendlyFromTicketKey(ticketKey);
    var title = i18next.t('ticket.reopened');
    var body = i18next.t('ticket.reopened.body.extended', {
      ticketId: ticketIdUIFriendly,
      actor: actorName
    });
    dispatch(spawnTicketNotification(ticketKey, title, body));
  };
};
export var onTopEventPushTypeTicketsBadgeCount = function onTopEventPushTypeTicketsBadgeCount(topData) {
  return function (dispatch) {
    addTicketLogEntry("tickets_badge_count: count ".concat(topData.data.count));
    var count = parseInt(topData.data.count, 10);
    dispatch(setTicketsBadgeCount(count));
  };
};
export var onTopEventPushOfTypeTicketAssigneeSet = function onTopEventPushOfTypeTicketAssigneeSet(topData) {
  return function (dispatch, getState) {
    addTicketLogEntry("Top event ticket_assignee_set: ticketKey ".concat(topData.data.ticketKey, ", new ").concat(topData.data.newValue, ", prev ").concat(topData.data.prevValue, ", actor ").concat(topData.data.actor));
    var ticketKey = topData.data.ticketKey;
    var assigneeKey = topData.data.newValue;
    var actorKey = topData.data.actor;
    var assigneeSetBySystem = !actorKey; //When the ticket is assigned by answering the call
    var ownExtensionKey = getOwnExtensionKey(getState());
    var ticketFromAppState = selectTicket(getState(), ticketKey);
    var lastUpdate = topData.data.ticketLastUpdate;
    if (lastUpdate) {
      dispatch(setTicketLastUpdate(ticketKey, lastUpdate));
    }
    if (ticketFromAppState) {
      var timestamp = topData.data.date;
      var assigneeChangedEventDto = {
        DTOSubtype: 'OmniAssigneeChangedEvent',
        key: topData.data.actionKey,
        newValue: assigneeKey,
        prevValue: topData.data.prevValue,
        actor: actorKey || 'SYSTEM',
        timeStamp: timestamp
      };
      dispatch(addTicketEvent(assigneeChangedEventDto, ticketKey));
      dispatch(setTicketAssignee(ticketKey, assigneeKey, ownExtensionKey));
      var ticketState = ticketFromAppState.get('state');
      dispatch(modifyOpenTicketsAssignedToUserCountOnAssigneeChangeIfAppropriate(assigneeKey, topData.data.prevValue, ticketState, ownExtensionKey));
      dispatch(spawnAssigneeSetNotificationIfRelevant(ticketKey, ownExtensionKey, assigneeKey, actorKey, assigneeSetBySystem));
      return;
    }
    if (!previousOrNewAssigneeIsLoggedInUser(topData.data.prevValue, assigneeKey, ownExtensionKey)) {
      //No need to fetch ticket if it doesn't affect logged-in user
      return;
    }
    setTimeout(function () {
      //Sometimes the data in the ticket received from the API has not been updated when fetching
      //right after the top event is received, hence this timeout, of arbitrarily chosen 1 second
      dispatch(fetchTicket(ticketKey)).then(function (ticketData) {
        if (ticketData.assignee !== assigneeKey) {
          addTicketLogEntry("Ticket assignee ".concat(assigneeKey, " from Top mismatch with data fetched from API: ").concat(ticketData.assignee, ". TicketID: ").concat(ticketKey));
        }
        var ticketState = ticketData.state;
        dispatch(modifyOpenTicketsAssignedToUserCountOnAssigneeChangeIfAppropriate(assigneeKey, topData.data.prevValue, ticketState, ownExtensionKey));
        dispatch(spawnAssigneeSetNotificationIfRelevant(ticketKey, ownExtensionKey, assigneeKey, actorKey, assigneeSetBySystem));
      });
    }, ONE_SECOND_MILLISECONDS);
  };
};
export var onTopEventPushOfTypeTicketStateSet = function onTopEventPushOfTypeTicketStateSet(topData) {
  return function (dispatch, getState) {
    addTicketLogEntry("Top event ticket_status_set: ticketKey ".concat(topData.data.ticketKey, ", new ").concat(topData.data.newValue, ", prev ").concat(topData.data.prevValue, ", actor ").concat(topData.data.actor));
    var ticketKey = topData.data.ticketKey;
    var stateKey = topData.data.newValue;
    var actorKey = topData.data.actor;
    var ticketStatusIsSetBySystem = !actorKey;
    var ownExtensionKey = getOwnExtensionKey(getState());
    addTicketLogEntry("".concat(ticketKey, " set to ").concat(stateKey, " by ").concat(actorKey));
    var ticketFromAppState = selectTicket(getState(), ticketKey);
    var lastUpdate = topData.data.ticketLastUpdate;
    if (lastUpdate) {
      dispatch(setTicketLastUpdate(ticketKey, lastUpdate));
    }
    if (ticketFromAppState) {
      var timestamp = topData.data.date;
      var stateChangedEventDto = {
        DTOSubtype: 'OmniStateChangedEvent',
        key: topData.data.actionKey,
        newValue: stateKey,
        prevValue: topData.data.prevValue,
        actor: actorKey || 'SYSTEM',
        timeStamp: timestamp
      };
      dispatch(addTicketEvent(stateChangedEventDto, ticketKey));
      dispatch(setTicketState(ticketKey, stateKey, ownExtensionKey));
      var assigneeKey = ticketFromAppState.get('assignee');
      dispatch(modifyOpenTicketsAssignedToUserCountOnTicketStateChangeIfAppropriate(stateKey, topData.data.prevValue, assigneeKey, ownExtensionKey));
      dispatch(spawnTicketStatusSetToOpenNotificationIfRelevant(ticketKey, ownExtensionKey, assigneeKey, stateKey, actorKey, ticketStatusIsSetBySystem));
      return;
    }
    if (stateKey !== 'open') {
      return;
    }

    //Sometimes the data in the ticket received from the API has not been updated when fetching
    //right after the top event is received, hence this timeout, of arbitrarily chosen 1 second
    setTimeout(function () {
      dispatch(fetchTicket(ticketKey)).then(function (ticketData) {
        if (ticketData.state !== stateKey) {
          addTicketLogEntry("Ticket state ".concat(stateKey, " from Top mismatch with data fetched from API: ").concat(ticketData.state, ". TicketID: ").concat(ticketKey));
        }
        var assigneeKey = ticketData.assignee;
        dispatch(modifyOpenTicketsAssignedToUserCountOnTicketStateChangeIfAppropriate(stateKey, topData.data.prevValue, assigneeKey, ownExtensionKey));
        dispatch(spawnTicketStatusSetToOpenNotificationIfRelevant(ticketKey, ownExtensionKey, assigneeKey, stateKey, actorKey, ticketStatusIsSetBySystem));
      });
    }, ONE_SECOND_MILLISECONDS);
  };
};
var getSenderDataFromSender = function getSenderDataFromSender(sender) {
  return {
    sender: sender,
    senderType: isExtensionKey(sender) ? 'ACCOUNT' : 'EXTERNAL'
  };
};
export var onTopEventPushOfTypeTicketSmsReceived = function onTopEventPushOfTypeTicketSmsReceived(topData) {
  return function (dispatch, getState) {
    addTicketLogEntry("Top event ticket_new_sms_note: ticketKey ".concat(topData.data.ticketKey, ", messageKey ").concat(topData.data.messageKey, ", actor ").concat(topData.data.actor));
    var ticketKey = topData.data.ticketKey;
    var message = topData.data.message;
    var sender = topData.data.actor;
    var timestamp = topData.data.date;
    var messageKey = topData.data.messageKey;
    var internalNoteEventDto = {
      DTOSubtype: 'OmniSmsNoteTicketEvent',
      message: message,
      senderData: getSenderDataFromSender(sender),
      timeStamp: timestamp,
      read: true,
      key: messageKey
    };
    var actorIsOwnExtension = sender === selectOwnExtensionKey(getState());
    var lastUpdate = topData.data.ticketLastUpdate;
    if (lastUpdate) {
      dispatch(applyPushedTicketLastUpdate(ticketKey, lastUpdate));
    }
    dispatch(addTicketEvent(internalNoteEventDto, ticketKey, actorIsOwnExtension, 'TOP'));
  };
};
export var onTopEventPushOfTypeTicketInternalNoteReceived = function onTopEventPushOfTypeTicketInternalNoteReceived(topData) {
  return function (dispatch, getState) {
    addTicketLogEntry("Top event ticket_new_internal_note: ticketKey ".concat(topData.data.ticketKey, ", messageKey ").concat(topData.data.messageKey, ", actor ").concat(topData.data.actor));
    var ticketKey = topData.data.ticketKey;
    var message = topData.data.message;
    var sender = topData.data.actor;
    var timestamp = topData.data.date;
    var messageKey = topData.data.messageKey;
    var mentionedAccounts = topData.data.mentionedAccounts || [];
    var internalNoteEventDto = {
      DTOSubtype: 'OmniInternalNoteTicketEvent',
      message: message,
      senderData: getSenderDataFromSender(sender),
      timeStamp: timestamp,
      read: true,
      key: messageKey,
      numberOfAttachments: topData.data.numberOfAttachments
    };
    var actorIsOwnExtension = sender === selectOwnExtensionKey(getState());
    var lastUpdate = topData.data.ticketLastUpdate;
    if (lastUpdate) {
      dispatch(applyPushedTicketLastUpdate(ticketKey, lastUpdate));
    }
    dispatch(addTicketEvent(internalNoteEventDto, ticketKey, actorIsOwnExtension, 'TOP'));
    // The push carries no stylings, so its mentions show as plain text until
    // the note is fetched with them. Only a pushed copy needs that: the
    // sending client already has the note with its stylings from the send
    // response, or has dropped the push while that response is on its way.
    if (mentionedAccounts.length > 0 && selectTicketEventsIsMounted(getState(), ticketKey) && selectMessageEventLacksStylings(getState(), ticketKey, messageKey)) {
      dispatch(fetchTicketMessage(ticketKey, messageKey));
    }
    dispatch(displayMentionNotificationIfAppropriate(ticketKey, sender, message, mentionedAccounts));
  };
};
var getIconForTicketEventDtoSubtype = function getIconForTicketEventDtoSubtype(dtoSubtype) {
  if (!dtoSubtype) return null;
  if (dtoSubtype === 'OmniWhatsAppMessageTicketEvent') return icon_whatsapp;
  if (dtoSubtype === 'OmniWhatsAppTemplateMessageTicketEvent') return icon_whatsapp;
  if (dtoSubtype === 'OmniWhatsAppUnsupportedTicketEvent') return icon_whatsapp;
  if (dtoSubtype === 'OmniEmailMessageTicketEvent') return icon_email;
  return null;
};
var onTicketMessageTopEventReceived = function onTicketMessageTopEventReceived(topData, dtoSubtype) {
  return function (dispatch, getState) {
    var sender = topData.data.actor;
    var message = topData.data.message;
    var eventDTO = {
      DTOSubtype: dtoSubtype,
      direction: topData.data.direction,
      key: topData.data.messageKey,
      message: message,
      senderData: getSenderDataFromSender(sender),
      timeStamp: topData.data.date,
      numberOfAttachments: topData.data.numberOfAttachments || 0
    };
    var ownExtensionKey = selectOwnExtensionKey(getState());
    var actorIsOwnExtension = sender === ownExtensionKey;
    var ticketKey = topData.data.ticketKey;
    var isEmailMessage = dtoSubtype === 'OmniEmailMessageTicketEvent';
    var lastUpdate = topData.data.ticketLastUpdate;
    if (lastUpdate) {
      dispatch(applyPushedTicketLastUpdate(ticketKey, lastUpdate));
    }
    if (!isEmailMessage) {
      // We add email messages to the store only when we fetch the full message data after receiving the Top event,
      // to avoid having the email message stored as plain text (e.g. without the HTML version of the message, which is not included in the Top message).
      // For other message types, we can add them to the store right away when receiving the top event.
      dispatch(addTicketEvent(eventDTO, ticketKey, actorIsOwnExtension, 'TOP'));
    }
    var state = getState();
    if (selectTicketEventsIsMounted(state, ticketKey)) {
      if (isEmailMessage) {
        // If it's an email message, we fetch full message data so that we receive the HTML version of the message
        dispatch(fetchTicketMessage(ticketKey, topData.data.messageKey));
      }
      if (selectAppIsVisibleAndFocused(state)) return;
      // If the view of the ticket in question is open and the app is in focus, we return, not moving on to the
      // notification spawning logic, as we do not want to display a notification in this case.
    }
    if (actorIsOwnExtension) return; // Action performed by the logged-in user, no need to display notification
    if (topData.data.ticketAssignee !== ownExtensionKey) return; // Logged-in user is not assigned to the ticket, no need to display notification
    if (topData.data.direction !== 'INCOMING') return; // Message is outgoing (e.g. from a colleague or system welcome/closed message; no need to display notification)

    var title = i18next.t('tickets.message.from', {
      sender: prettyFormatE164Number(sender, selectUserCountryCode(state))
    });
    dispatch(spawnTicketNotification(ticketKey, title, message, getIconForTicketEventDtoSubtype(dtoSubtype)));
  };
};
export var onTopEventPushTypeTicketEmailMessageReceived = function onTopEventPushTypeTicketEmailMessageReceived(topData) {
  return function (dispatch) {
    addTicketLogEntry("Top event ticket_new_email_message. messageKey: ".concat(topData.data.messageKey));
    dispatch(onTicketMessageTopEventReceived(topData, 'OmniEmailMessageTicketEvent'));
  };
};
export var onTopEventPushOfTypeTicketWhatsAppMessageReceived = function onTopEventPushOfTypeTicketWhatsAppMessageReceived(topData) {
  return function (dispatch) {
    addTicketLogEntry("Top event ticket_new_whatsapp_message. messageKey: ".concat(topData.data.messageKey));
    dispatch(onTicketMessageTopEventReceived(topData, 'OmniWhatsAppMessageTicketEvent'));
  };
};
export var onTopEventTicketWhatsAppTemplateMessage = function onTopEventTicketWhatsAppTemplateMessage(topData) {
  return function (dispatch) {
    addTicketLogEntry("Top event ticket_new_whatsapp_template_message. messageKey: ".concat(topData.data.messageKey));
    dispatch(onTicketMessageTopEventReceived(topData, 'OmniWhatsAppTemplateMessageTicketEvent'));
  };
};
export var onTopEventPushOfTypeTicketWhatsAppUnsupportedMessage = function onTopEventPushOfTypeTicketWhatsAppUnsupportedMessage(topData) {
  return function (dispatch) {
    addTicketLogEntry("Top event ticket_unsupported_whatsapp_message. messageKey: ".concat(topData.data.messageKey));
    dispatch(onTicketMessageTopEventReceived(topData, 'OmniWhatsAppUnsupportedTicketEvent'));
  };
};
export var displayMentionNotificationIfAppropriate = function displayMentionNotificationIfAppropriate(ticketKey, sender, message) {
  var mentionees = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  return function (dispatch, getState) {
    if (mentionees.length === 0) return;
    if (selectTicketEventsIsMounted(getState(), ticketKey)) return; // Not displaying notification if ticket view is open

    var ownExtensionKey = selectOwnExtensionKey(getState());
    if (!mentionees.some(function (m) {
      return m.key === ownExtensionKey;
    })) return;
    var ticketIdUserFriendly = getTicketIdUiFriendlyFromTicketKey(ticketKey);
    var title = i18next.t('tickets.ticket_id', {
      ticketId: ticketIdUserFriendly
    });
    var senderName = getExtensionContactFirstNameLastName(getState(), sender);
    var senderNameUIFriendly = getStringWithFirstLetterFromSecondWord(senderName);
    var body = i18next.t('message.name_message', {
      name: senderNameUIFriendly,
      message: message
    });
    dispatch(spawnTicketNotification(ticketKey, title, body));
  };
};
export var onTopEventPushOfTypeTicketCreatedReceived = function onTopEventPushOfTypeTicketCreatedReceived(topData) {
  return function (dispatch, getState) {
    addTicketLogEntry("Top event ticket_new_ticket: ticketKey ".concat(topData.data.ticketKey, ", originKey ").concat(topData.data.originKey, ", locutusSessionId ").concat(topData.data.locutusSessionId));
    if (!selectTicketsTabIsEnforced(getState())) {
      dispatch(setTicketsTabIsEnforcedForUser(true));
    }
    var ticketKey = topData.data.ticketKey;
    var locutusSessionId = topData.data.locutusSessionId;
    var originKey = topData.data.originKey;
    if (locutusSessionId) {
      dispatch({
        type: Actions.SET_TICKET_KEY_FOR_LOCUTUS_SESSION,
        locutusSessionId: locutusSessionId,
        ticketKey: ticketKey
      });
    }
    var lastUpdate = topData.data.ticketLastUpdate;
    if (lastUpdate) {
      dispatch(setTicketLastUpdate(ticketKey, lastUpdate));
    }
    var ticketsTabIsMounted = !!selectTicketsListIsMounted(getState());
    var pbxPageForOriginKeyIsMounted = isTypeQueueKey(originKey) ? selectPbxPageIsMounted(getState(), originKey) : false;
    if (pbxPageForOriginKeyIsMounted) {
      dispatch(setTicketKeyForQueueCallRecord(originKey, "call-".concat(locutusSessionId), ticketKey));
    }
    if (ticketsTabIsMounted) {
      setTimeout(function () {
        if (!selectTicketIsFetched(getState(), ticketKey)) {
          dispatch(fetchTicket(ticketKey));
        }
        // About if block above:
        // If we've already fetched the ticket (e.g. via the TicketListItem),
        // we don't need to fetch it again here.
      }, ONE_SECOND_MILLISECONDS);
    }
  };
};
var setTicketKeyForQueueCallRecord = function setTicketKeyForQueueCallRecord(queueKey, callKey, ticketKey) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_OMNI_TICKET_KEY_QUEUE_CALL,
      queueKey: queueKey,
      callKey: callKey,
      ticketKey: ticketKey
    });
  };
};
export var onTopEventTicketMessageStatusSet = function onTopEventTicketMessageStatusSet(topData) {
  return function (dispatch) {
    var ticketKey = topData.data.ticketKey;
    var lastUpdate = topData.data.ticketLastUpdate;
    if (lastUpdate) {
      dispatch(applyPushedTicketLastUpdate(ticketKey, lastUpdate));
    }
    dispatch(setTicketMessageStatus(ticketKey, topData.data.messageKey, topData.data.newValue));
  };
};
export var setTicketMessageStatus = function setTicketMessageStatus(ticketKey, messageKey, messageStatus) {
  return function (dispatch) {
    return dispatch({
      type: Actions.SET_TICKET_EVENT_MESSAGE_STATUS,
      ticketKey: ticketKey,
      messageKey: messageKey,
      messageStatus: messageStatus
    });
  };
};
export var onTopEventPushOfTypeTicketMembersChanged = function onTopEventPushOfTypeTicketMembersChanged(topData) {
  return function (dispatch, getState) {
    var ticketKey = topData.data.ticketKey;
    var membersAdded = topData.data.addedExtensions || [];
    var membersRemoved = topData.data.removedExtensions || [];
    var actor = topData.data.actor;
    addTicketLogEntry("Top event ticket_members_change: ticketKey ".concat(ticketKey, ", added ").concat(membersAdded.length, ", removed ").concat(membersRemoved.length, ", actor ").concat(actor));
    var ownExtensionKey = getOwnExtensionKey(getState());
    var lastUpdate = topData.data.ticketLastUpdate;
    if (lastUpdate) {
      dispatch(setTicketLastUpdate(ticketKey, lastUpdate));
    }
    if (membersAdded.includes(ownExtensionKey)) {
      //Logged-in user added to ticket, fetch relevant tickets data
      if (!selectTicketsTabIsEnforced(getState())) {
        dispatch(setTicketsTabIsEnforcedForUser(true));
        dispatch(fetchTicketsBadgeCount());
      }
      setTimeout(function () {
        if (qualifiesForTicketFetch(getState(), ticketKey)) {
          dispatch(fetchTicket(ticketKey));
        }
      }, ONE_SECOND_MILLISECONDS);
    } else if (membersRemoved.includes(ownExtensionKey)) {
      // Dispatched even when the logged-in user is the actor, because a
      // second instance of the app has no API callback of its own and would
      // otherwise keep the ticket. Whichever report arrives first removes it
      // and navigates; the other finds it gone and does nothing.
      var actorIsOwnUser = actor === ownExtensionKey;
      dispatch(onOwnUserRemovedFromTicket(ticketKey, actorIsOwnUser, membersAdded, membersRemoved));
    } else {
      dispatch(applyTicketMembersChange(ticketKey, membersAdded, membersRemoved));
    }
  };
};
var getBooleanValue = function getBooleanValue(value) {
  return typeof value === 'boolean' ? value : value === 'true';
};
export var onTopEventTicketAwaitingActivitySet = function onTopEventTicketAwaitingActivitySet(topData) {
  return function (dispatch, getState) {
    addTicketLogEntry("Top event ticket_awaiting_activity_set: ticketKey ".concat(topData.data.ticketKey, ", newValue ").concat(topData.data.newValue));
    var ticketKey = topData.data.ticketKey;
    var newValueBoolean = getBooleanValue(topData.data.newValue);
    var ownExtensionKey = selectOwnExtensionKey(getState());
    var lastUpdate = topData.data.ticketLastUpdate;
    if (lastUpdate) {
      dispatch(setTicketLastUpdate(ticketKey, lastUpdate));
    }
    if (topData.data.ticketAssignee === ownExtensionKey && qualifiesForTicketFetch(getState(), ticketKey)) {
      dispatch(fetchTicket(ticketKey));
    } else {
      dispatch(setAwaitingActivity(ticketKey, newValueBoolean));
    }
  };
};
export var onTopEventTicketSubjectSet = function onTopEventTicketSubjectSet(topData) {
  return function (dispatch, getState) {
    var ticketKey = topData.data.ticketKey;
    var lastUpdate = topData.data.ticketLastUpdate;
    if (lastUpdate) {
      dispatch(applyPushedTicketLastUpdate(ticketKey, lastUpdate));
    }
    dispatch(setTicketSubject(ticketKey, topData.data.newValue));
    var ticketFromAppState = selectTicket(getState(), ticketKey);
    if (ticketFromAppState) {
      var timestamp = topData.data.date;
      var subjectChangedEventDto = {
        DTOSubtype: 'OmniSubjectChangedEvent',
        key: topData.data.actionKey,
        newValue: topData.data.newValue,
        prevValue: topData.data.prevValue,
        actor: topData.data.actor || 'SYSTEM',
        timeStamp: timestamp
      };
      dispatch(addTicketEvent(subjectChangedEventDto, ticketKey));
    }
  };
};

// No action is recorded for this change, so there is no timeline event to add.
// Every recipient is a member, the assignee or the actor, so a narrowing tier
// never costs them access — nothing here has to fetch or drop the ticket.
export var onTopEventTicketVisibilitySet = function onTopEventTicketVisibilitySet(topData) {
  return function (dispatch) {
    addTicketLogEntry("Top event ticket_visibility_set: ticketKey ".concat(topData.data.ticketKey, ", newValue ").concat(topData.data.newValue));
    var ticketKey = topData.data.ticketKey;
    var lastUpdate = topData.data.ticketLastUpdate;
    if (lastUpdate) {
      dispatch(applyPushedTicketLastUpdate(ticketKey, lastUpdate));
    }
    var visibility = ticketVisibilityFromWire(topData.data.newValue);
    if (visibility) {
      dispatch(setTicketVisibility(ticketKey, visibility));
    }
  };
};
export var onTopEventTicketTranscriptionProgress = function onTopEventTicketTranscriptionProgress(topData) {
  return function (dispatch, getState) {
    addTicketLogEntry("Top event ticket_transcription_progress: ticketKey ".concat(topData.data.ticketKey, ", state ").concat(topData.data.transcriptionState, ", actor ").concat(topData.data.actor));
    var ticketKey = topData.data.ticketKey;
    var actor = topData.data.actor;
    var transcriptionState = topData.data.transcriptionState;
    var lastUpdate = topData.data.ticketLastUpdate;
    if (lastUpdate) {
      dispatch(applyPushedTicketLastUpdate(ticketKey, lastUpdate));
    }
    if (transcriptionState !== 'completed') return;

    // The feed refresh and the notification are the whole point of this event now: the
    // in-progress and scroll-to-recording flags it used to set had no readers left once the
    // ticket call card started rendering from the shared call-record components.
    if (selectTicketEventsIsMounted(getState(), ticketKey)) {
      dispatch(fetchTicketEvents(ticketKey));
      return;
    }
    if (actor === selectOwnExtensionKey(getState())) {
      dispatch(spawnTicketNotification(ticketKey, i18next.t('ai.transcribe.completed_notification'), i18next.t('ai.transcribe.completed_click_view')));
    }
  };
};
export var updateAwaitingActivity = function updateAwaitingActivity(ticketKey, value) {
  return function (dispatch) {
    return dispatch(patchTicket(ticketKey, {
      awaitingActivity: value
    }));
  };
};
export var refreshTicketsData = function refreshTicketsData() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var state, ticketsListIsMounted, tabSelected, ticketKeysMounted, _iterator, _step, ticketKey, ticketHasBeenFetched, _t, _t2;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            state = getState();
            if (selectShouldSeeTicketsTab(state)) {
              _context.next = 1;
              break;
            }
            return _context.abrupt("return");
          case 1:
            dispatch(clearTicketsData);
            dispatch(fetchTicketsBadgeCount());
            _context.next = 2;
            return dispatch(fetchOpenTicketsAssignedToUserLatest);
          case 2:
            ticketsListIsMounted = selectTicketsListIsMounted(state);
            if (!ticketsListIsMounted) {
              _context.next = 8;
              break;
            }
            dispatch(fetchTotalNumberOfTicketsOpenAssignedToLoggedInUser);
            tabSelected = selectTicketsListTabSelected(state);
            _t = tabSelected;
            _context.next = _t === TICKETS_LIST_TABS_KEYS.UNASSIGNED ? 3 : _t === TICKETS_LIST_TABS_KEYS.ALL ? 5 : 7;
            break;
          case 3:
            _context.next = 4;
            return dispatch(fetchOpenTicketsUnassignedLatest);
          case 4:
            return _context.abrupt("continue", 8);
          case 5:
            _context.next = 6;
            return dispatch(fetchTicketsAllLatest);
          case 6:
            return _context.abrupt("continue", 8);
          case 7:
            return _context.abrupt("continue", 8);
          case 8:
            ticketKeysMounted = selectTicketViewsMountedData(state);
            if (!(ticketKeysMounted && !ticketKeysMounted.isEmpty())) {
              _context.next = 16;
              break;
            }
            _iterator = _createForOfIteratorHelper(ticketKeysMounted.keys());
            _context.prev = 9;
            _iterator.s();
          case 10:
            if ((_step = _iterator.n()).done) {
              _context.next = 13;
              break;
            }
            ticketKey = _step.value;
            ticketHasBeenFetched = selectTicketIsFetched(state, ticketKey);
            if (ticketHasBeenFetched) {
              _context.next = 11;
              break;
            }
            _context.next = 11;
            return dispatch(fetchTicket(ticketKey));
          case 11:
            dispatch(fetchTicketEvents(ticketKey));
          case 12:
            _context.next = 10;
            break;
          case 13:
            _context.next = 15;
            break;
          case 14:
            _context.prev = 14;
            _t2 = _context["catch"](9);
            _iterator.e(_t2);
          case 15:
            _context.prev = 15;
            _iterator.f();
            return _context.finish(15);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[9, 14, 15, 16]]);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var removeOpenAiExperimentalTagFromTicket = function removeOpenAiExperimentalTagFromTicket(ticketKey, tag) {
  return function (dispatch) {
    dispatch({
      type: Actions.REMOVE_TICKET_OPEN_AI_EXPERIMENTAL_TAG,
      tag: tag,
      ticketKey: ticketKey
    });
  };
};
var setTotalNumberOfRelatedTickets = function setTotalNumberOfRelatedTickets(ticketKey, count) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_TOTAL_RELATED_TICKETS_COUNT,
      count: count,
      ticketKey: ticketKey
    });
  };
};
var setTicket = function setTicket(ticketKey, ticketDTO) {
  return function (dispatch) {
    dispatch({
      type: Actions.UPDATE_TICKET,
      ticketKey: ticketKey,
      ticketDTO: ticketDTO
    });
    dispatch({
      type: Actions.UPDATE_TICKET_TEMP_SEARCH_DATA,
      ticketKey: ticketKey,
      ticketDTO: ticketDTO
    });
  };
};
var setClosedTickets = function setClosedTickets(data, nextPageNumber, apiHasMoreData) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_CLOSED_TICKETS_DATA,
      data: data,
      nextPageNumber: nextPageNumber,
      apiHasMoreData: apiHasMoreData
    });
  };
};
var setOpenTicketsAssignedToUserData = function setOpenTicketsAssignedToUserData(data, nextPageNumber, apiHasMoreData) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_OPEN_TICKETS_ASSIGNED_USER_DATA,
      data: data,
      nextPageNumber: nextPageNumber,
      apiHasMoreData: apiHasMoreData
    });
  };
};
var setOpenTicketsUnassignedData = function setOpenTicketsUnassignedData(data, nextPageNumber, apiHasMoreData) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_OPEN_TICKETS_UNASSIGNED_DATA,
      data: data,
      nextPageNumber: nextPageNumber,
      apiHasMoreData: apiHasMoreData
    });
  };
};
var setTicketsAllData = function setTicketsAllData(data, nextPageNumber, apiHasMoreData) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_TICKETS_ALL_DATA,
      data: data,
      nextPageNumber: nextPageNumber,
      apiHasMoreData: apiHasMoreData
    });
  };
};
var setTicketData = function setTicketData(data, ownExtensionKey) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_TICKET_DATA,
      data: data,
      ownExtensionKey: ownExtensionKey
    });
  };
};
var setTicketEvents = function setTicketEvents(data, ticketKey) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_TICKET_EVENTS,
      ticketKey: ticketKey,
      data: data
    });

    // Consolidated call events (v3) carry a full CallRecordDTO. Upsert it into the canonical
    // call-records store so the ticket call card renders from the same data/selectors as the
    // call record page. The include scope tells the reducer which fields this payload is
    // authoritative for, so a recording/contact/action removed server-side clears here too
    // instead of lingering from an earlier richer fetch.
    data.forEach(function (event) {
      var _event$callRecord;
      if (eventIsCallRecordEvent(event === null || event === void 0 ? void 0 : event.DTOSubtype) && (_event$callRecord = event.callRecord) !== null && _event$callRecord !== void 0 && _event$callRecord.key) {
        dispatch({
          type: Actions.RESULT_CALL_RECORD,
          callRecordKey: event.callRecord.key,
          data: event.callRecord,
          include: CALL_RECORD_INCLUDES_TICKET_EVENT
        });
      }
    });
  };
};
var addTicketEvent = function addTicketEvent(eventData, ticketKey, actorIsOwnExtension, dataSource) {
  return function (dispatch) {
    dispatch({
      type: Actions.ADD_TICKET_EVENT,
      ticketKey: ticketKey,
      eventData: eventData,
      actorIsOwnExtension: actorIsOwnExtension,
      dataSource: dataSource
    });
  };
};
var setTicketAssignee = function setTicketAssignee(ticketKey, assigneeKey, ownExtensionKey) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_TICKET_ASSIGNEE,
      ticketKey: ticketKey,
      assigneeKey: assigneeKey,
      ownExtensionKey: ownExtensionKey
    });
  };
};
var setTicketState = function setTicketState(ticketKey, ticketState, ownExtensionKey) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_TICKET_STATE,
      ticketKey: ticketKey,
      ticketState: ticketState,
      ownExtensionKey: ownExtensionKey
    });
  };
};
export var applyTicketMembersChange = function applyTicketMembersChange(ticketKey, membersAdded, membersRemoved) {
  return function (dispatch) {
    dispatch({
      type: Actions.APPLY_TICKET_MEMBERS_CHANGE,
      ticketKey: ticketKey,
      membersAdded: membersAdded,
      membersRemoved: membersRemoved
    });
  };
};
var incrementTicketsOpenAssignedToUserCount = function incrementTicketsOpenAssignedToUserCount(dispatch) {
  dispatch({
    type: Actions.INCREMENT_TICKETS_OPEN_ASSIGNED_USER_COUNT_TOTAL
  });
};
var decrementTicketsOpenAssignedToUserCount = function decrementTicketsOpenAssignedToUserCount(dispatch) {
  dispatch({
    type: Actions.DECREMENT_TICKETS_OPEN_ASSIGNED_USER_COUNT_TOTAL
  });
};
var setTotalNumberOfTicketsOpenAssignedToLoggedInUser = function setTotalNumberOfTicketsOpenAssignedToLoggedInUser(count) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_TICKETS_OPEN_ASSIGNED_USER_COUNT_TOTAL,
      count: count
    });
  };
};
var setTicketsBadgeCount = function setTicketsBadgeCount(count) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_TICKETS_BADGE_COUNT,
      count: count
    });
  };
};
export var setTicketsListMountStatus = function setTicketsListMountStatus(isMounted, tabSelected) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_TICKETS_LIST_MOUNT_STATUS,
      isMounted: isMounted,
      tabSelected: tabSelected
    });
  };
};
export var setTicketViewMountStatus = function setTicketViewMountStatus(isMounted, ticketKey, context) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_TICKET_VIEW_MOUNT_STATUS,
      isMounted: isMounted,
      ticketKey: ticketKey,
      context: context
    });
  };
};
export var setTicketEventsMountStatus = function setTicketEventsMountStatus(ticketKey, isMounted) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_TICKET_EVENTS_MOUNT_STATUS,
      isMounted: isMounted,
      ticketKey: ticketKey
    });
  };
};
var clearTicketsData = function clearTicketsData(dispatch) {
  dispatch({
    type: Actions.CLEAR_TICKETS_DATA
  });
};
var setTicketsSettingsInStoreForQueue = function setTicketsSettingsInStoreForQueue(queueEntityKey, ticketSettingsDTO) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_TICKETS_SETTINGS_FOR_QUEUE,
      queueEntityKey: queueEntityKey,
      data: ticketSettingsDTO
    });
  };
};
var setDefaultTicketVisibilityInStoreForQueue = function setDefaultTicketVisibilityInStoreForQueue(queueEntityKey, defaultTicketVisibilityDTO) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_DEFAULT_TICKET_VISIBILITY_FOR_QUEUE,
      queueEntityKey: queueEntityKey,
      data: _objectSpread(_objectSpread({}, defaultTicketVisibilityDTO), {}, {
        visibility: ticketVisibilityFromWire(defaultTicketVisibilityDTO === null || defaultTicketVisibilityDTO === void 0 ? void 0 : defaultTicketVisibilityDTO.visibility)
      })
    });
  };
};
export var setTicketsTabIsEnforcedForUser = function setTicketsTabIsEnforcedForUser(value) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_TICKETS_TAB_ENFORCED,
      value: value
    });
  };
};
export var fetchEmailSignaturesEnabled = function fetchEmailSignaturesEnabled() {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      TicketsResource.getEmailSignaturesEnabled({
        onResult: function onResult(value) {
          dispatch({
            type: Actions.SET_EMAIL_SIGNATURES_ENABLED,
            value: value
          });
          resolve(value);
        },
        onClientError: function onClientError() {
          reject();
        },
        onError: function onError() {
          networkErrorDispatcher(dispatch);
          reject();
        }
      });
    });
  };
};
export var setTicketsRelatedData = function setTicketsRelatedData(ticketKey, data, nextPageNumber, apiHasMoreData) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_TICKETS_RELATED_DATA,
      ticketKey: ticketKey,
      data: data,
      nextPageNumber: nextPageNumber,
      apiHasMoreData: apiHasMoreData
    });
  };
};
var setTagsAvailableForTicketTagging = function setTagsAvailableForTicketTagging(data) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_ALL_TAGS_AVAILABLE_FOR_TICKET_TAGGING,
      data: data
    });
  };
};
var setTagRemovedFromTicket = function setTagRemovedFromTicket(ticketKey, tagKey) {
  return function (dispatch) {
    dispatch({
      type: Actions.REMOVE_TAG_FROM_TICKET,
      ticketKey: ticketKey,
      tagKey: tagKey
    });
  };
};
var setRenameTag = function setRenameTag(tagKey, newName) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_RENAME_TAG,
      tagKey: tagKey,
      newName: newName
    });
  };
};
var setDeleteTagsCompletely = function setDeleteTagsCompletely(tagKeys) {
  return function (dispatch) {
    dispatch({
      type: Actions.DELETE_TAGS_COMPLETELY,
      tagKeys: tagKeys
    });
  };
};
var setNewTagCreated = function setNewTagCreated(tagData) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_NEW_TAG_CREATED,
      tagData: tagData
    });
  };
};
export var addTagToTicket = function addTagToTicket(ticketKey, label, tagKey, source) {
  return function (dispatch, getState) {
    var tagDto = _objectSpread(_objectSpread(_objectSpread({}, tagKey ? {
      key: tagKey
    } : {}), source ? {
      source: source
    } : {}), label ? {
      label: label
    } : {});
    return new Promise(function (resolve, reject) {
      TicketsResource.addTag({
        onResult: function onResult(json) {
          var tagExistsInAvailableTags = selectTagExistsInAvailableTags(getState(), tagKey, label);
          if (!tagExistsInAvailableTags) {
            var _json$tags;
            var tagAdded = (_json$tags = json.tags) === null || _json$tags === void 0 ? void 0 : _json$tags.find(function (tag) {
              return tag.label === label;
            });
            if (tagAdded) {
              dispatch(setNewTagCreated(tagAdded));
            }
          }
          var ownExtensionKey = getOwnExtensionKey(getState());
          dispatch(setTicketData(json, ownExtensionKey));
          resolve(json);
        },
        onClientError: function onClientError(error) {
          dispatch(onTicketWriteRefused(ticketKey, error));
          reject(error);
        },
        onError: function onError(error) {
          networkErrorDispatcher(dispatch);
          reject(error);
        }
      }, ticketKey, tagDto);
    });
  };
};
export var fetchAllAvailableTags = function fetchAllAvailableTags() {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      TicketsResource.fetchAllTags({
        onResult: function onResult(json) {
          dispatch(setTagsAvailableForTicketTagging(json));
          resolve(json);
        },
        onClientError: function onClientError(error) {
          reject(error);
        },
        onError: function onError(error) {
          networkErrorDispatcher(dispatch);
          reject(error);
        }
      });
    });
  };
};
export var removeTagFromTicket = function removeTagFromTicket(ticketKey, tagKey, label) {
  return function (dispatch, getState) {
    var _selectTagFromAllTags;
    var keyOfTagToRemove = tagKey || ((_selectTagFromAllTags = selectTagFromAllTagsWithLabel(getState(), label)) === null || _selectTagFromAllTags === void 0 ? void 0 : _selectTagFromAllTags.get('key'));
    return new Promise(function (resolve, reject) {
      if (!keyOfTagToRemove) {
        // Without a key the request would go to /tags/undefined and 404.
        reject(new Error("No key found for tag with label ".concat(label)));
        return;
      }
      TicketsResource.removeTag({
        onResult: function onResult(json) {
          dispatch(setTagRemovedFromTicket(ticketKey, keyOfTagToRemove));
          resolve(json);
        },
        onClientError: function onClientError(error) {
          dispatch(onTicketWriteRefused(ticketKey, error));
          reject(error);
        },
        onError: function onError(error) {
          networkErrorDispatcher(dispatch);
          reject(error);
        }
      }, ticketKey, keyOfTagToRemove);
    });
  };
};
export var deleteTagsCompletely = function deleteTagsCompletely(tagKeys) {
  return function (dispatch) {
    return new Promise(function (resolve /*, reject*/) {
      dispatch(setDeleteTagsCompletely(tagKeys));
      resolve();
      /*
      TicketsResource.deleteTag(
          {
              onResult(json) {
                  dispatch(setDeleteTagCompletely(tagKey));
                  resolve(json);
              },
              onClientError: (error) => {
                  reject(error);
              },
              onError: (error) => {
                  networkErrorDispatcher(dispatch);
                  reject(error);
              },
          },
          tagKey
      );
      */
    });
  };
};
export var renameTag = function renameTag(tagKey, newName) {
  return function (dispatch) {
    return new Promise(function (resolve /*, reject*/) {
      dispatch(setRenameTag(tagKey, newName));
      resolve();
      /*
      TicketsResource.renameTag(
          {
              onResult(json) {
                  dispatch(setRenameTag(tagKey, newName));
                  resolve(json);
              },
              onClientError: (error) => {
                  reject(error);
              },
              onError: (error) => {
                  networkErrorDispatcher(dispatch);
                  reject(error);
              },
          },
          tagKey
      );
      */
    });
  };
};
export var sendWhatsAppTemplateMessage = function sendWhatsAppTemplateMessage(ticketKey, templateName, language) {
  return function (dispatch) {
    var messageObject = JSON.stringify({
      template_name: templateName,
      language: language
    });
    return new Promise(function (resolve, reject) {
      TicketsResource.sendWhatsAppTemplateMessage({
        onResult: function onResult(json) {
          resolve(json);
          // WHATSAPP TO DO:
          // Remove once we have a Top event for this
          dispatch(addTicketEvent(json, ticketKey));
        },
        onClientError: function onClientError(error) {
          dispatch(onTicketWriteRefused(ticketKey, error));
          reject(error);
        },
        onError: function onError(error) {
          networkErrorDispatcher(dispatch);
          reject(error);
        }
      }, ticketKey, messageObject);
    });
  };
};
export var generateSummary = function generateSummary(ticketKey, context) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'SHORT';
  return function (dispatch) {
    var requestDTO = {
      summaryType: type,
      summaryContext: context
    };
    return new Promise(function (resolve, reject) {
      TicketsResource.generateAISummary({
        onResult: function onResult(json) {
          resolve(json);
        },
        onClientError: function onClientError(error) {
          reject(error);
        },
        onError: function onError(error) {
          networkErrorDispatcher(dispatch);
          reject(error);
        }
      }, ticketKey, requestDTO);
    });
  };
};
export var fetchWhatsAppTemplates = function fetchWhatsAppTemplates(ticketKey) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      TicketsResource.getWhatsAppTemplates({
        onResult: function onResult(payload) {
          resolve(payload);
        },
        // Reading the templates is behind the write gate, because they
        // only exist to be sent.
        onClientError: function onClientError(error) {
          dispatch(onTicketWriteRefused(ticketKey, error));
          reject(error);
        },
        onError: function onError(error) {
          networkErrorDispatcher(dispatch);
          reject(error);
        }
      }, ticketKey);
    });
  };
};
var getIconForTicketChannel = function getIconForTicketChannel(channel) {
  if (!channel) return null;
  if (channel === 'whatsapp') return icon_whatsapp;
  if (channel === 'email') return icon_email;
  return null;
};
export var spawnNotificationNewTicket = function spawnNotificationNewTicket(ticketKey, message, channel, notificationKey) {
  return function (dispatch) {
    var title = i18next.t('tickets.conversation.new');
    dispatch(spawnTicketNotification(ticketKey, title, message, getIconForTicketChannel(channel), notificationKey));
  };
};
var setAwaitingActivity = function setAwaitingActivity(ticketKey, value) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_TICKET_AWAITING_ACTIVITY,
      ticketKey: ticketKey,
      value: value
    });
  };
};

// A ticket-scoped Top push carries ticketLastUpdate — the ticket's new
// LASTUPDATED, the field ticket lists sort by — whenever the event moved it.
// Handlers apply it when present; WHICH events move it is owned by the
// backend. The reducer only ever moves the value forward (max-guard), so
// out-of-order pushes are safe.
var setTicketLastUpdate = function setTicketLastUpdate(ticketKey, value) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_TICKET_LAST_UPDATED,
      ticketKey: ticketKey,
      value: value
    });
  };
};

// A pushed ticket update is worth fetching only when we don't already have the
// ticket and the tickets list is mounted to display it.
var qualifiesForTicketFetch = function qualifiesForTicketFetch(state, ticketKey) {
  return !selectTicketIsFetched(state, ticketKey) && !!selectTicketsListIsMounted(state);
};

// Applies a server-pushed lastUpdate from a Top event: if the ticket qualifies
// for a fetch (not loaded + list mounted), fetch it — the fetched ticket carries
// the current lastUpdate — otherwise set it in place (a no-op when we don't have
// the ticket). Handlers that fetch on their own relevance rules
// (assignee/state/members/awaiting) and the created event don't use this.
var applyPushedTicketLastUpdate = function applyPushedTicketLastUpdate(ticketKey, lastUpdate) {
  return function (dispatch, getState) {
    if (qualifiesForTicketFetch(getState(), ticketKey)) {
      dispatch(fetchTicket(ticketKey));
    } else {
      dispatch(setTicketLastUpdate(ticketKey, lastUpdate));
    }
  };
};
var setTicketSubject = function setTicketSubject(ticketKey, value) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_TICKET_SUBJECT,
      ticketKey: ticketKey,
      value: value
    });
  };
};
var setTicketVisibility = function setTicketVisibility(ticketKey, value) {
  return function (dispatch) {
    dispatch({
      type: Actions.SET_TICKET_VISIBILITY,
      ticketKey: ticketKey,
      value: value
    });
  };
};
export var createTicketForCallRecord = function createTicketForCallRecord(callRecordKey, queueKey) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var state, ownExtensionKey, queueMembers, memberKeys, data;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            state = getState();
            ownExtensionKey = selectOwnExtensionKey(state);
            queueMembers = selectQueueMembers(state, queueKey);
            memberKeys = queueMembers ? queueMembers.map(function (m) {
              return m.get('extensionKey');
            }).toArray() : [];
            _context2.next = 1;
            return dispatch(createTicketForQueueCall(callRecordKey, memberKeys, ownExtensionKey));
          case 1:
            data = _context2.sent;
            _context2.next = 2;
            return dispatch(fetchTicket(data.key));
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var forwardTicketToQueue = function forwardTicketToQueue(ticketKey, queueKey) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      TicketsResource.forwardTicket({
        onResult: function onResult(json) {
          dispatch(setTicket(ticketKey, json));
          resolve(json);
        },
        onClientError: function onClientError(error) {
          dispatch(onTicketWriteRefused(ticketKey, error));
          reject(error);
        },
        onError: function onError(error) {
          networkErrorDispatcher(dispatch);
          reject(error);
        }
      }, ticketKey, {
        queueEntityKey: queueKey
      });
    });
  };
};